import React, { Component } from 'react';
import SortableTree from 'react-sortable-tree';
import EnterpriseBreadcrumb from './../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';
import {connect} from 'react-redux';
import { getFlatDataFromTree,changeNodeAtPath,getNodeAtPath } from 'react-sortable-tree';
import find from 'lodash/find';
import * as actionCreators from '../../../modules/actions/index';

import Select from 'react-select';
import { updateOffice } from '../../../utils/url';


class ChangeOfficeHierarchy extends Component {

  constructor(props) {
    super(props);
    this.state = {
        searchedTerm : '',
        newName:"",
        updatedOffices: this.props.orgChart.updatedOffices ?this.props.orgChart.updatedOffices :[],
        sortType: 'a-z',
        staticHierarchy: this.props.orgChart.temporaryHierarchy ? this.props.orgChart.temporaryHierarchy:this.props.user.profile.organizationId.staticHierarchy,
        availableOffices:this.props.orgChart.manageNewOffices?this.props.orgChart.manageNewOffices:[],
        selectedValues: this.props.orgChart.disabledOffices?this.props.orgChart.disabledOffices: [],
        isHidden:false
    }
  }

  changeName=(value)=>{
    console.log(value)
    this.setState({newName:value.label})
  }
  
  componentDidMount=()=>{
    // console.log('component MOUNTED')
    // this.props.saveDisabledOffices([])
    // this.props.saveUpdatedOffices([])

  }

  officeNameArray = (node,val)=>{
      console.log(node, val)
      if(node.officeNameArr && node.officeNameArr.length>0){
          return [...node.officeNameArr, val ]
      } else {
           return [val]
      }
  }

  renderOptions =()=>{
    // let {availableOffices}=this.state
    let{manageNewOffices}=this.props.orgChart
    let{selectedValues}=this.state
    // console.log(selectedValues)
    let val = manageNewOffices.map(e=>{
      return selectedValues.indexOf(e.label)===-1? {...e, disabled:false} : {...e, disabled:true} 
    })

    // this.props.manageNewOffices(val)
    return val 

  }


  changeNewOfficeOptions = (value) => {
    let{availableOffices}=this.state
    console.log(value)
    let newOffices = availableOffices.map(e=>{
      if(value===e.label){
        if(e.isSelected && e.isSelected===true){
          e.isSelected=false
        }else {
          e.isSelected=true
        }
      } else {
        e.isSelected=false
      }
      return e
    })
    console.log(newOffices)
    this.setState({availableOffices:newOffices})
  }


  renderOfficeOptions=()=>{
    let {availableOffices, selectedValues}=this.state
    console.log(availableOffices)
    return availableOffices.map( (e, idx) =>{
      // let isFound = selectedValues.indexOf(e.label)>-1?true:false
      let isFound = false;
      return(
        <p className={ isFound?"newOfficesFoundContentSelected":"newOfficesFoundContent"} key={idx}> {e.label} </p>
      )
    })
  }


  reviewHierarchyChanges=()=>{
    let {staticHierarchy,updatedOffices, selectedValues}=this.state
    this.props.saveHierarchyChanges(staticHierarchy)
    this.props.saveUpdatedOffices(updatedOffices)
    // disabled
    this.props.saveDisabledOffices(selectedValues)
    this.props.history.push(`/home/enterprise-info/org-chart/management/review`)
  } 

  goBacktoManagement = () =>{
    let {staticHierarchy,updatedOffices,selectedValues}=this.state
    this.props.saveHierarchyChanges(staticHierarchy)
    this.props.saveUpdatedOffices(updatedOffices)
    // disabled
    this.props.saveDisabledOffices(selectedValues)
    this.props.history.push(`/home/enterprise-info/org-chart/management/`)
  }
  

  render() { 
    let {staticHierarchy,availableOffices,selectedValues, updatedOffices, newName}=this.state
    let{manageNewOffices}=this.props.orgChart
    console.log(this.state,this.props)

    return ( 
      <div>
        <div className="mt30">
          <div className="title-text">
            Change Names in Hierarchy
          </div>
        </div>
        <hr/>
        
        <div className="mt40 mb40 org-chart-description-text">

          <div className="alert-msg-bg mt50">
            <i className="close-icon">close</i>
            <div className="d-flex custom-message-box">
              <i className="material-icons alert-icon-bg">remove_circle</i>
              <span className="ml10 alert-msg-text">
                
                <span className="newOfficesFoundTxt">
                The following {manageNewOffices.length} Office(s) names were not found:  
                </span>
                {this.renderOfficeOptions()}
                {/* {availableOffices.map( (e, idx) =>{

                  return(
                    <p className="newOfficesFoundContent" key={idx}> {e.label} </p>
                  )
                })}  */}
              </span>
            </div>
          </div> 

        </div>


        <SortableTree
          treeData={staticHierarchy}
          // canDrag={() => {}}
          onChange={staticHierarchy => this.setState({ staticHierarchy })}
          generateNodeProps={({ node, path }) => ({
            className:"drag-node",
            title: (
            <div>
                {/* {node.title===""} */}
                <span>
                    {node.title}
                </span>
                <br/>

                <Select
                value={newName?newName:node.title}
                options={this.renderOptions()}
                isOptionDisabled={m => m.disabled !== false}
                onChange={(value) => {
                  let{staticHierarchy}=this.state
                  let newDate = new Date()

                  if(value===null || value==="undefined" || !value ) {
                        const name = node.title

                        this.changeNewOfficeOptions(name)
                        const flat = getFlatDataFromTree({treeData : staticHierarchy,getNodeKey: ({ node }) => 
                        node.id,ignoreCollapsed: false } );
                        const allOfficePaths = flat.map((p) => {
                            // console.log(p)
                          const o = {};
                          o.path = p.path.join('#');
                          o.name = p.node.title
                          return o;
                        });

                       
                        
                        const map = find(allOfficePaths,{name: name});

                        let oldName; 
                        
                        updatedOffices.map(e=>{
                          if(e.newName===map.name){
                           oldName=e.oldName
                          } 
                        })
                        
      
                        this.setState(state => ({
                          updatedOffices:updatedOffices.filter(e=>e.newName!==name),
                          selectedValues:selectedValues.filter(e=>e!==name),
                          staticHierarchy: changeNodeAtPath({
                            treeData: state.staticHierarchy,
                            path: map.path.split("#"),
                            getNodeKey: ({ node }) => node.id,
                            newNode: { 
                                ...node, 
                                archivedOfficeNames: node.archivedOfficeNames.slice(0, -1),
                                title: oldName, 
                               },
                            newName:name,
                          }),
                        }));
                    }


                    if(value && value.value){
                      const name = value.value


                      this.changeNewOfficeOptions(name)
                        const flat = getFlatDataFromTree({treeData : staticHierarchy,getNodeKey: ({ node }) => 
                        node.id,ignoreCollapsed: false } );
                        // console.log(flat)
                        const allOfficePaths = flat.map((p) => {
                          // console.log(p)
                          const o = {};
                          o.path = p.path.join('#');
                          o.name = p.node.title;
                          return o;
                        });
                        const map = find(allOfficePaths,{name: node.title});

                        let isUpdate 
                        updatedOffices.map(e=>{
                          if(e.newName===map.name){
                            isUpdate=true
                            
                          } 
                        })

                        let archivedOffices =  this.officeNameArray(node, 
                          { title: node.title,date: Date.now(), isoDate:newDate.toISOString()})

                        if(isUpdate){
                          selectedValues=selectedValues.filter(e=>e!==map.name)
                          selectedValues.push(name)
                          updatedOffices.map(e=>{
                            if(e.newName === map.name){
                              e.newName =name;
                            }
                            return e
                          })

                        }else{
                          // console.log(name)
                            selectedValues.push(name)
                            
                            updatedOffices.push({oldName:node.title, newName:name, path:map.path, archivedOffices:archivedOffices})
                        }

                        
                        // console.log(updatedOffices, selectedValues)


                        this.setState(state => ({
                          updatedOffices,
                          selectedValues,
                          staticHierarchy: changeNodeAtPath({
                            treeData: state.staticHierarchy,
                            path: map.path.split("#"),
                            getNodeKey: ({ node }) => node.id,
                            newNode: { 
                                ...node, title:name, 
                                archivedOfficeNames:archivedOffices
                                    // this.officeNameArray(node, 
                                    //         { title: node.title,date: Date.now(), isoDate:newDate.toISOString()})
                            },
                            newName:name,
                          }),
                        }));
                    }
                  }}
                clearable={true}
              />
               
              </div>
            ),
          })}
          canDrag={({ node }) => !node.dragDisabled}
          isVirtualized={false}
        />

       <span className="float-left officeHierarchyBackBtn btn btn-secondary-filled"
       onClick={this.goBacktoManagement} 
      //  onClick={()=>this.props.history.push(`/home/enterprise-info/org-chart/management/`) }
       >
               Back to Hierarchy management
              </span>

              <span className="float-right officeHierarchyContinueBtn btn btn-secondary" onClick={this.reviewHierarchyChanges}>
               Continue
              </span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user : state.user,
    orgChart:state.orgChart
  }
}

const mapDispatchToProps = dispatch => {
	return {
    saveHierarchyChanges: (hierarchy) => dispatch(actionCreators.saveHierarchyChanges(hierarchy)),
    saveDisabledOffices: (disabledOffices) => dispatch(actionCreators.saveDisabledOffices(disabledOffices)),
    saveUpdatedOffices: (updatedOffices) => dispatch(actionCreators.saveUpdatedOffices(updatedOffices)),
	}
}

 
export default connect(mapStateToProps,mapDispatchToProps)(ChangeOfficeHierarchy);